/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import * as attorney from './attorney';
import * as insuranceQC from './insuranceQC';
import * as multiTenantTPR from './multiTenantTPR';
import * as notary from './notary';
import * as opsDesk from './opsDesk';
import * as settlementAgent from './settlementAgent';
import * as titleAgent from './titleAgent';
import * as loanProcessor from './loanProcessor';
export const isUnsignedESignNotificationPersona = persona => 'getESignBannerConfig' in persona && 'shouldShowUnsignedESignUIs' in persona && 'shouldDownloadModalInterrupt' in persona && 'shouldUploadModalInterrupt' in persona;
export const isClosingPersona = persona => 'getClosingTypeCopy' in persona && 'showSpecialInstructions' in persona;
export const isLastSentAtPersona = persona => 'getLastSentAtRow' in persona;

// Temporary interface until all personas have their own getSidebar implementation

export const isSidebarImplementedPersona = persona => 'getSidebar' in persona;
export const isProfilePersona = persona => 'getRegisrationFormOverrides' in persona && 'renderProfileHeader' in persona;
export const isPipelinePersona = persona => 'renderPipelineFilter' in persona && 'getPipelineFilters' in persona;
const personas = {
  attorney,
  insurance_qc_agent: insuranceQC,
  loan_processor: loanProcessor,
  multi_tenant_tpr: multiTenantTPR,
  notary,
  ops_desk_agent: opsDesk,
  settlement_agent: settlementAgent,
  title_agent: titleAgent
};
export const getPersona = principalType => {
  return personas[principalType];
};
export const getPipelineFilters = _filterParams => {
  return [];
};
export const renderPipelineFilter = (_filters, _onFilterChanged) => undefined;